import * as constants from '../constants';

export default function (state = [], { type, payload }) {
  switch (type) {
    case constants.SCHEDULED_MONTH_END_SEARCH:
      return { ...state, ["scheduled_month_end_search_data"]: payload.data };
    default:
      return state
  }
}